module.exports = __webpack_public_path__ + "img/Support-skill-234.bedad964.png";